import React from "react";

export function ListGroupItem({ className, as, children, ...props }) {
  const computedClassName = ["list-group-item", ...className.split(" ")]
    .join(" ")
    .trim();
  return React.cloneElement(
    as,
    { className: computedClassName, ...props },
    children,
  );
}

ListGroupItem.defaultProps = {
  className: "",
  as: <li />,
};

export default function ListGroup({ className, as, children, ...props }) {
  const computedClassName = ["list-group", ...className.split(" ")]
    .join(" ")
    .trim();
  return React.cloneElement(
    as,
    { className: computedClassName, ...props },
    children,
  );
  // return <ul className={computedClassName}>{children}</ul>;
}

ListGroup.defaultProps = {
  className: "",
  as: <ul />,
};
